import React from 'react';
import { useSelector } from 'react-redux';
import { HEADING } from '../../../../../components/heading/constants/constants';
import Heading from '../../../../../components/heading/Heading';
import Loadable from '../../../../../components/loadable/Loadable';
import { CREATE_FORMS_LOADING_STATES, CREATE_FORM_STATES_MESSAGE_MAP, FORM_STEP } from '../../constants';
import { componentKey } from '../../CreateFormSlice';
import RenderFields from '../components/RenderFields';
import RenderInteractionElement from '../components/RenderInteractionElement';
import styles from './OtherInformation.styles';

export default function OtherInformation() {

    const { loadingState, toCreateFormData, tempFormFieldsList, onDependentFields, formsPreLoadedData, userInteractionPopupWResponseObj } = useSelector((state) => state[componentKey]);
    
    return <>
        <div style={styles.mainContainer}>
            <div style={styles.titleRow}>
                <div style={styles.headerTitle}>
                    <Heading type={HEADING.H1} >
                        You are doing great! Now start filling the other information
                    </Heading>
                </div>
            </div>
            <Loadable
                currentState={loadingState.state} 
                messageMap={CREATE_FORM_STATES_MESSAGE_MAP}
                loadingStates={[CREATE_FORMS_LOADING_STATES.DEPENDENT_FIELD_CHANGE_LOADING, CREATE_FORMS_LOADING_STATES.SAVING_FORM_LOADING]} 
                isNewLoadable={true}
                preserveChildMount={true}
            >    
                <div style={styles.boxListContainer}>
                    <div style={styles.boxListRow}>
                        <div style={styles.selectedBoxesValuesContainer}>
                            <RenderFields step={FORM_STEP.OTHER} tempFormFieldsList={tempFormFieldsList} formsPreLoadedData={formsPreLoadedData} toCreateFormData={toCreateFormData} onDependentFields={onDependentFields} />
                        </div>
                    </div>
                </div>
            </Loadable>
        </div>
        {
            (userInteractionPopupWResponseObj?.type) ? <RenderInteractionElement interactionObj={userInteractionPopupWResponseObj}  userInteractionPopupWResponseObj={userInteractionPopupWResponseObj}/> : ""
        }
    </>
}